export type OneriProgram = {
  id: string;
  sigla: string;
  nome: string;
  descrizione: string;
  finanziamento: string;
  projectUrl: string;
  references: Array<{ label: string; url: string }>;
  color: string;
  badgeColor: string;
};

export const ONERI_PROGRAMS: OneriProgram[] = [
  {
    id: 'onere-giada',
    sigla: 'GIADA',
    nome: 'Guida Interattiva ADHD',
    descrizione:
      "GIADA rende il patrimonio culturale più accessibile alle persone con ADHD grazie a interfacce semplificate, contenuti adattivi e percorsi inclusivi.",
    finanziamento:
      'GIADA è finanziato dall’Unione Europea – NextGenerationEU tramite avviso pubblico PNRR, Missione 1 – Digitalizzazione, innovazione, competitività e cultura, Componente 3 – Turismo e Cultura 4.0 (M1C3), Misura 3 “Industria culturale e creativa 4.0”, Investimento 3.3 “Capacity building per gli operatori della cultura per gestire la transizione digitale e verde”, Sub-Investimento 3.3.2 - Sostegno ai settori culturali e creativi per l’innovazione e la transizione digitale (Azione A II).',
    projectUrl: 'https://www.thethinkingclouds.com/it/projects/giada',
    references: [
      { label: 'Scheda progetto GIADA', url: 'https://www.thethinkingclouds.com/it/projects/giada' },
      { label: 'NextGenerationEU', url: 'https://next-generation-eu.europa.eu/index_it' },
      { label: 'Italia Domani PNRR', url: 'https://www.italiadomani.gov.it' },
    ],
    color: 'border-primary bg-primary/5',
    badgeColor: 'bg-primary text-white',
  },
  {
    id: 'onere-hera',
    sigla: 'HERA',
    nome: 'cultural Heritage Empathetic Response Algorithms',
    descrizione:
      'HERA sviluppa algoritmi per assistenti virtuali empatici che rendono la fruizione dei beni culturali più naturale e coinvolgente.',
    finanziamento:
      'HERA è cofinanziato dall’Unione Europea, dallo Stato Italiano e dalla Regione Campania, nell’ambito del POR Campania FESR 2014-2020.',
    projectUrl: 'https://www.thethinkingclouds.com/it/projects/hera',
    references: [
      { label: 'Scheda progetto HERA', url: 'https://www.thethinkingclouds.com/it/projects/hera' },
      { label: 'Commissione Europea', url: 'https://ec.europa.eu' },
      { label: 'Regione Campania', url: 'https://www.regione.campania.it' },
      { label: 'POR Campania FESR', url: 'https://porfesr.regione.campania.it' },
    ],
    color: 'border-tertiary bg-tertiary/5',
    badgeColor: 'bg-tertiary text-white',
  },
  {
    id: 'onere-eidelon',
    sigla: 'EIDELON',
    nome: 'Robotica e AI per esperienze culturali',
    descrizione:
      'EIDELON è un robot interattivo per musei e beni culturali che guida i visitatori con AI conversazionale, visione artificiale e interfacce digitali.',
    finanziamento:
      'Progetto cofinanziato dalla Regione Campania nell’ambito dell’Azione 3.1.1 “Aiuti per investimenti in macchinari, impianti e beni intangibili e accompagnamento dei processi di riorganizzazione e ristrutturazione aziendale” dell’Asse III “Competitività dei sistemi produttivi” del POR Campania FESR 2014-2020, nel rispetto della normativa comunitaria relativa alla programmazione dei Fondi Strutturali 2014-2020.',
    projectUrl: 'https://www.thethinkingclouds.com/it/projects/eidelon',
    references: [
      { label: 'Scheda progetto EIDELON', url: 'https://www.thethinkingclouds.com/it/projects/eidelon' },
      { label: 'Regione Campania', url: 'https://www.regione.campania.it' },
      { label: 'POR Campania FESR', url: 'https://porfesr.regione.campania.it' },
    ],
    color: 'border-accent bg-accent/10',
    badgeColor: 'bg-accent text-secondary',
  },
  {
    id: 'onere-genius-loci',
    sigla: 'GENIUS LOCI',
    nome: 'Piattaforma cloud per la fruizione dei beni culturali',
    descrizione:
      'Glooci è l’app che trasforma ogni visita in un’esperienza culturale coinvolgente grazie al Genius Loci e all’intelligenza artificiale conversazionale.',
    finanziamento:
      'The Thinking Clouds è ammessa al programma CulturaCrea e ai benefici previsti dal Decreto del Ministero dei Beni e delle Attività Culturali e del Turismo dell’11 maggio 2016 – Titolo II, per la realizzazione di un programma di investimenti pari a Euro 214.825,00 per lo sviluppo di “Genius Loci”, una piattaforma cloud che consente di migliorare la fruizione dei beni culturali.',
    projectUrl: 'https://www.thethinkingclouds.com/it/projects/glooci',
    references: [
      { label: 'Scheda progetto GLOOCI', url: 'https://www.thethinkingclouds.com/it/projects/glooci' },
      { label: 'Invitalia Cultura Crea', url: 'https://www.invitalia.it/cosa-facciamo/rafforziamo-le-imprese/cultura-crea' },
      { label: 'Glooci', url: 'https://www.glooci.it' },
    ],
    color: 'border-secondary bg-secondary/5',
    badgeColor: 'bg-secondary text-white',
  },
];

export const ONERI_LINKS = ONERI_PROGRAMS.map((program) => ({
  label: program.sigla,
  href: `/oneri#${program.id}`,
}));

export const GENIUS_LOCI_FINANCING_TEXT =
  'The Thinking Clouds è ammessa al programma CulturaCrea e ai benefici previsti dal Decreto del Ministero dei Beni e delle Attività Culturali e del Turismo dell’11 maggio 2016 – Titolo II, per la realizzazione di un programma di investimenti pari a Euro 214.825,00 per lo sviluppo di “Genius Loci”.';
